import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function DropAdmin() {
  const [key, setKey] = useState("");
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [current, setCurrent] = useState(null);
  const [saving, setSaving] = useState(false);
  const dirty = useRef(false);

  useEffect(() => {
    api.drop().then((d) => {
      setCurrent(d);
      if (!dirty.current) {
        setName(d.name);
        setDate(d.date.slice(0, 16));
      }
    }).catch(() => {});
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const updated = await api.updateDrop({ name, date }, key);
      setCurrent(updated);
      toast.success("DROP UPDATED.");
    } catch (err) {
      toast.error(err.response?.status === 401 ? "Wrong key." : "Couldn't save. Try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-5 pt-14 pb-10" data-testid="drop-admin-page">
      <p className="font-college text-lg text-red">KEEP THIS PAGE TO YOURSELF</p>
      <h1 className="font-college text-4xl sm:text-5xl text-navy mt-2" data-testid="drop-admin-heading">DROP MANAGER</h1>
      {current && (
        <p className="text-sm text-ink/60 mt-3" data-testid="drop-admin-current">
          Currently: {current.name} — {new Date(current.date).toLocaleString()}
        </p>
      )}
      <form onSubmit={save} className="space-y-4 mt-8" data-testid="drop-admin-form">
        <div>
          <label className="font-college text-base block mb-1.5" htmlFor="drop-admin-key">ADMIN KEY</label>
          <input
            id="drop-admin-key"
            data-testid="drop-admin-key-input"
            type="password"
            required
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="The secret key"
            className="w-full bg-white px-3 py-2.5 text-sm shadow-print-sm focus:outline-none focus:ring-2 focus:ring-red"
          />
        </div>
        <div>
          <label className="font-college text-base block mb-1.5" htmlFor="drop-admin-name">DROP NAME</label>
          <input
            id="drop-admin-name"
            data-testid="drop-admin-name-input"
            required
            value={name}
            onChange={(e) => { dirty.current = true; setName(e.target.value); }}
            placeholder="HALLOWEEN"
            className="w-full bg-white px-3 py-2.5 text-sm shadow-print-sm focus:outline-none focus:ring-2 focus:ring-red uppercase"
          />
        </div>
        <div>
          <label className="font-college text-base block mb-1.5" htmlFor="drop-admin-date">DROP DATE &amp; TIME</label>
          <input
            id="drop-admin-date"
            data-testid="drop-admin-date-input"
            type="datetime-local"
            required
            value={date}
            onChange={(e) => { dirty.current = true; setDate(e.target.value); }}
            className="w-full bg-white px-3 py-2.5 text-sm shadow-print-sm focus:outline-none focus:ring-2 focus:ring-red"
          />
        </div>
        <button
          data-testid="drop-admin-save"
          type="submit"
          disabled={saving}
          className="w-full bg-red text-paper font-college text-xl py-3 shadow-print hover:bg-navy transition-colors disabled:opacity-60"
        >
          {saving ? "SAVING…" : "UPDATE THE DROP"}
        </button>
      </form>
    </div>
  );
}
